import React, { memo, useEffect, useRef } from "react";
import { Box, Paper, Typography } from "@mui/material";
import { FaWifi } from "react-icons/fa";
import { BsBatteryFull, BsSignal } from "react-icons/bs";

const IPhone16Frame = ({ url, showNotch }) => {
  const time = new Date().toLocaleTimeString("en-GB", {
    hour: "2-digit",
    minute: "2-digit",
  });

  const iframeRef = useRef(null);

  useEffect(() => {
    const iframe = iframeRef.current;
    // reload iframe
    if (iframe) {
      iframe.src = url;
    }
  }, []);

  return (
    <Paper
      elevation={5}
      sx={{
        width: "320px",
        aspectRatio: "9 / 19.5",
        borderRadius: "40px",
        border: "8px solid black",
        position: "relative",
        overflow: "hidden",
        backgroundColor: "#000",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        margin: "0 auto",
      }}
    >
      {/* iOS Status Bar */}
      {showNotch && (
        <Box
          sx={{
            width: "93%",
            height: "44px",
            position: "absolute",
            top: 0,
            left: 0,
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            padding: "0 12px",
            color: "#fff",
            backgroundColor: "rgba(0, 0, 0, 0.3)",
            backdropFilter: "blur(10px)",
            zIndex: 10,
          }}
        >
          {/* Left Section (Time) */}
          <Typography
            variant="body2"
            sx={{
              fontSize: "15px",
              fontWeight: 600,
              lineHeight: 1,
            }}
          >
            {time}
          </Typography>

          {/* Dynamic Island (iPhone 16-style notch) */}
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translateX(-50%) translateY(-50%)",
              width: "96px",
              height: "28px",
              backgroundColor: "#000",
              borderRadius: "24px",
              zIndex: 1,
            }}
          />

          {/* Right Section (Icons) */}
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: "6px",
              zIndex: 2,
            }}
          >
            <BsSignal size={16} />
            <FaWifi size={16} />
            <BsBatteryFull size={16} />
          </Box>
        </Box>
      )}

      {/* Screen - Using iFrame */}
      <Box
        sx={{
          width: "100%",
          height: "100%",
          backgroundColor: "#fff",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          paddingTop: showNotch ? "43px" : "0px",
          paddingBottom: showNotch ? "10px" : "0px",
        }}
      >
        <iframe
          ref={iframeRef}
          src={url}
          title="Mobile Preview"
          loading="lazy"
          style={{
            width: "100%",
            height: "100%",
            border: "none",
            transform: "scale(1)",
            transformOrigin: "top left",
          }}
        />
      </Box>

      {/* iOS Navigation Bar (Gesture Pill) */}
      {showNotch && (
        <Box
          sx={{
            width: "100%",
            height: "24px",
            position: "absolute",
            bottom: 0,
            left: 0,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            backgroundColor: "rgba(0, 0, 0, 0.3)",
            backdropFilter: "blur(10px)",
          }}
        >
          <Box
            sx={{
              width: "120px",
              height: "4px",
              backgroundColor: "#ccc",
              borderRadius: "2px",
            }}
          />
        </Box>
      )}
    </Paper>
  );
};

export default memo(IPhone16Frame);